import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import * as PropTypes from 'prop-types';

export default function ProductDeleteDialog(props) {
  const { open, toggleDialog, productId, handleDeleteProduct } = props;

  return (
    <div>
      <Dialog open={open} onClose={toggleDialog}>
        <DialogTitle>Delete Product?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Deleted products cannot be restored by Gastrograph. If a product is
            deleted, <strong>product reviews</strong> will not be deleted.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={toggleDialog} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDeleteProduct(productId);
            }}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ProductDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  productId: PropTypes.number.isRequired,
  handleDeleteProduct: PropTypes.func.isRequired
};
